import { API_ROOT } from '../../config/config'
import { doGet, doPost } from './utils'

// const API_ROOT2 = 'http://localhost/api'

export const searchExpert = (request, pagenum = 0, pagesize = 0) => {
  const url = `${API_ROOT}/review/reviewer/assign/pagenum/${pagenum}/pagesize/${pagesize}`
  return doPost(url, request)
}

export const searchExpertAI = (request, projectId) => {
  const url = `${API_ROOT}/review/${projectId}/reviewer/assign/ai`
  return doPost(url, request)
}

export const getSchemaAssignExpert = (projectId) => {
  const url = `${API_ROOT}/review/${projectId}/page/assign`
  return doGet(url)
}

export const getSchemaSendAssignExpert = (projectId) => {
  const url = `${API_ROOT}/review/${projectId}/page/send`
  return doGet(url)
}

export const sendAssignExpert = (request) => {
  const url = `${API_ROOT}/review/reviewer-added`
  return doPost(url, request)
}

export const sendAssignExpertSended = (request) => {
  const url = `${API_ROOT}/review/reviewer-sended`
  return doPost(url, request)
}

//ขั้นที่ 1 เลือกผู้ทรงคุณวุฒิ หลายโครงการ
export const getSchemaAssignExpertMuti = (request, pagesize, pagenumber) => {
  const url = `${API_ROOT}/multiple/scrutinize/expert/step1/pagesize/${pagesize}/pagenumber/${pagenumber}`
  return doPost(url, request)
}

export const getAssignExpertMutiData = (request, pagesize, pagenumber) => {
  const url = `${API_ROOT}/multiple/scrutinize/expert/widget/pagesize/${pagesize}/pagenumber/${pagenumber}`
  return doPost(url, request)
}

export const saveAssignExpertMittingMulti = (request) => {
  const url = `${API_ROOT}/review/multi/assign-expert/mitting/add`
  return doPost(url, request)
}

//ขั้นที่ 2 เลือกผู้ทรงคุณวุฒิ หลายโครงการ
export const getSchemaSendAssignExpertMulti = (request, pagesize, pagenumber) => {
  // const url = `http://localhost:9011/api/multiple/scrutinize/expert/step2/pagesize/${pagesize}/pagenumber/${pagenumber}`
  const url = `${API_ROOT}/multiple/scrutinize/expert/step2/pagesize/${pagesize}/pagenumber/${pagenumber}`
  console.log(url)
  return doPost(url, request)
}

export const saveSendAssignExpertMuti = (request) => {
  const url = `${API_ROOT}/review/multi/reviewer-sended`
  // const url = `${API_ROOT}/multiple/scrutinize/expert/step2/add`
  return doPost(url, request)
}
